module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "新增参展商品",
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    ref: "filters",
    staticStyle: {
      "display": "flex",
      "height": "36px",
      "margin-top": "-20px",
      "margin-bottom": "6px"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "商品名称："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商品名称/型号/标语",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.goodsName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "goodsName", $$v)
      },
      expression: "filters.goodsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "品类："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getbrandarr
    },
    model: {
      value: (_vm.filters.brandTypeId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandTypeId", $$v)
      },
      expression: "filters.brandTypeId"
    }
  }, _vm._l((_vm.brandTypearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "品牌："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.brandId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandId", $$v)
      },
      expression: "filters.brandId"
    }
  }, _vm._l((_vm.brandarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-right": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("查 询")])], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    staticClass: "ban_tab",
    staticStyle: {
      "height": "auto",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.goods,
      "row-key": _vm.getRowKeys,
      "stripe": "",
      "border": "",
      "header-cell-style": {
        background: '#bbbbbb'
      }
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "reserve-selection": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodModelCode",
      "label": "产品型号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodModelCode
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.GoodModelCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Title",
      "label": "名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.Title
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.Title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodsTypeName",
      "label": "品类",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodsTypeName
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.GoodsTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BrandName",
      "label": "品牌",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BrandName
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.BrandName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BbName",
      "label": "所属品牌商",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BbName
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.BbName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "check",
      "label": "是否秒杀商品",
      "width": "270px",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          attrs: {
            "value": _vm.getCheck(scope.row.Id),
            "reserve-selection": true
          },
          on: {
            "change": function($event) {
              return _vm.setCheck(scope.row.Id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total,
      "current-page": _vm.pageIndex
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.dataFormSubmit()
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e5760b42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/addExhibitorsCategory.vue
// module id = 1747
// module chunks = 3